const ABSOLUTE_PATHS = {
	LOGIN: "/login",
	HOME: "/home",
	// Eventos
	EVENT_LIST: "/eventos",
	CREATE_EVENT_MANUAL_LOADING: "/eventos/carga-manual/crear",
	UPDATE_EVENT_MANUAL_LOADING: "/eventos/carga-manual/editar",
	COMPLETE_DETAIL_EVENT_MANUAL_LOADING: "/eventos/detalle",
	CREATE_EVENT_MASSIVE_LOADING: "/eventos/carga-masiva",
	ATTENDANCE_EVENT: "/eventos/asistencia",
	DETAIL_EVENT: "/eventos/detalle",
	// Ref. Acad.
	ACAD_REINFORCE_LIST: "/ref-acad",
	CREATE_ACAD_REINFORCE_MANUAL_LOADING: "/ref-acad/carga-manual/crear",
	UPDATE_ACAD_REINFORCE_MANUAL_LOADING: "/ref-acad/carga-manual/editar",
	DETAIL_ACAD_REINFORCE: "/ref-acad/detalle",
	CREATE_ACAD_REINFORCE_MASSIVE_LOADING: "/ref-acad/carga-masiva",
	ATTENDANCE_ACAD_REINFORCE: "/ref-acad/asistencia",
	// Asesorías
	APPOINTMENT: "/asesorias",
	CREATE_APPOINTMENT: "/asesorias/crear",
	// Recursos
	RESOURCES: "/recursos",
	RESOURCES_LIBRARY: "/recursos/biblioteca",
	RESOURCES_UNIVERSITY_SPACES: "/recursos/espacios-universitarios",
	// Configuración
	SETTINGS: "/config",
	SETTINGS_ROLE_ADMIN: "/config/roles",
	SETTINGS_RESOURCE_SCHEDULE_ADMIN: "/config/horarios",
	SETTINGS_RESOURCE_PENALTY_ADMIN: "/config/sanciones",
	SETTINGS_SPACE_ADMIN: "/config/espacios/campus",
	SETTINGS_SPACE_ADMIN_CAMPUS_SPACES: "/config/espacios/campus-espacios",
	SETTINGS_SPACE_ADMIN_REGISTER: "/config/espacios/registrar",
	SETTINGS_SPACE_ADMIN_UPDATE: "/config/espacios/editar",
	// Dev
	USERS_PER_ROLE: "/usuarios-por-rol",
	TEST: "/test",
};

export default ABSOLUTE_PATHS;
